/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Confirm_WarningInputs */

const en_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete your account? This action cannot be undone.`)
};

const id_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda yakin ingin menghapus akun Anda? Tindakan ini tidak dapat dibatalkan.`)
};

const ms_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adakah anda pasti mahu memadamkan akaun anda? Tindakan ini tidak boleh dibatalkan.`)
};

const ca_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estàs segur que vols eliminar el teu compte? Aquesta acció no es pot desfer.`)
};

const cs_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opravdu chcete smazat svůj účet? Tuto akci nelze vrátit zpět.`)
};

const da_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er du sikker på, at du vil slette din konto? Denne handling kan ikke fortrydes.`)
};

const de_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`)
};

const et_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas olete kindel, et soovite oma konto kustutada? Seda toimingut ei saa tagasi võtta.`)
};

const es_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que deseas eliminar tu cuenta? Esta acción no se puede deshacer.`)
};

const fr_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voulez-vous vraiment supprimer votre compte ? Cette action ne peut pas être annulée.`)
};

const hr_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeste li sigurni da želite izbrisati svoj račun? Ova radnja ne može se poništiti.`)
};

const it_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare il tuo account? Questa azione non può essere annullata.`)
};

const lv_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai tiešām vēlaties dzēst savu kontu? Šo darbību nevar atsaukt.`)
};

const lt_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar tikrai norite ištrinti savo paskyrą? Šio veiksmo nebus galima atšaukti.`)
};

const hu_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biztosan törölni szeretné a fiókját? Ez a művelet nem vonható vissza.`)
};

const nl_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weet je zeker dat je je account wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.`)
};

const nb_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er du sikker på at du vil slette kontoen din? Dette kan ikke angres.`)
};

const pl_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy na pewno chcesz usunąć swoje konto? Tego działania nie można cofnąć.`)
};

const pt_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita.`)
};

const ro_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunteți sigur că vreți să ștergeți contul? Această acțiune nu poate fi anulată.`)
};

const sk_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Určite chcete vymazať svoj účet? Táto akcia sa nedá vrátiť späť.`)
};

const sl_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ali ste prepričani, da želite izbrisati svoj račun? Tega dejanja ni mogoče razveljaviti.`)
};

const fi_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oletko varma, että haluat poistaa tilisi? Tätä toimintoa ei voi perua.`)
};

const sv_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Är du säker på att du vill radera ditt konto? Denna åtgärd kan inte ångras.`)
};

const vi_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có chắc chắn muốn xóa tài khoản của mình không? Hành động này không thể hoàn tác.`)
};

const tr_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesabınızı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.`)
};

const el_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.`)
};

const bg_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сигурни ли сте, че искате да изтриете акаунта си? Тази действие не може да бъде отменено.`)
};

const ru_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить свой аккаунт? Это действие нельзя отменить.`)
};

const sr_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да ли сте сигурни да желите да избришете свој налог? Ова радња се не може опозвати.`)
};

const uk_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви дійсно хочете видалити свій обліковий запис? Цю дію не можна скасувати.`)
};

const ka_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`დარწმუნებული ხართ, რომ გსურთ თქვენი ანგარიშის წაშლა? ეს ქმედება უცვლელი იქნება.`)
};

const hi_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई अपना खाता हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती।`)
};

const th_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณแน่ใจหรือไม่ว่าต้องการลบบัญชีของคุณ การกระทำนี้ไม่สามารถยกเลิกได้`)
};

const ko_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`)
};

const zh_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您确定要删除账户吗？此操作无法撤销。`)
};

const zh_tw_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您確定要刪除您的帳戶嗎？此操作無法撤銷。`)
};

const ja_delete_account_confirm_warning = /** @type {(inputs: Delete_Account_Confirm_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを削除してもよろしいですか？この操作は元に戻せません。`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete your account? This action cannot be undone." |
*
* @param {Delete_Account_Confirm_WarningInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const delete_account_confirm_warning = /** @type {((inputs?: Delete_Account_Confirm_WarningInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Confirm_WarningInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_delete_account_confirm_warning(inputs)
	if (locale === "ms") return ms_delete_account_confirm_warning(inputs)
	if (locale === "ca") return ca_delete_account_confirm_warning(inputs)
	if (locale === "cs") return cs_delete_account_confirm_warning(inputs)
	if (locale === "da") return da_delete_account_confirm_warning(inputs)
	if (locale === "de") return de_delete_account_confirm_warning(inputs)
	if (locale === "et") return et_delete_account_confirm_warning(inputs)
	if (locale === "es") return es_delete_account_confirm_warning(inputs)
	if (locale === "fr") return fr_delete_account_confirm_warning(inputs)
	if (locale === "hr") return hr_delete_account_confirm_warning(inputs)
	if (locale === "it") return it_delete_account_confirm_warning(inputs)
	if (locale === "lv") return lv_delete_account_confirm_warning(inputs)
	if (locale === "lt") return lt_delete_account_confirm_warning(inputs)
	if (locale === "hu") return hu_delete_account_confirm_warning(inputs)
	if (locale === "nl") return nl_delete_account_confirm_warning(inputs)
	if (locale === "nb") return nb_delete_account_confirm_warning(inputs)
	if (locale === "pl") return pl_delete_account_confirm_warning(inputs)
	if (locale === "pt") return pt_delete_account_confirm_warning(inputs)
	if (locale === "ro") return ro_delete_account_confirm_warning(inputs)
	if (locale === "sk") return sk_delete_account_confirm_warning(inputs)
	if (locale === "sl") return sl_delete_account_confirm_warning(inputs)
	if (locale === "fi") return fi_delete_account_confirm_warning(inputs)
	if (locale === "sv") return sv_delete_account_confirm_warning(inputs)
	if (locale === "vi") return vi_delete_account_confirm_warning(inputs)
	if (locale === "tr") return tr_delete_account_confirm_warning(inputs)
	if (locale === "el") return el_delete_account_confirm_warning(inputs)
	if (locale === "bg") return bg_delete_account_confirm_warning(inputs)
	if (locale === "ru") return ru_delete_account_confirm_warning(inputs)
	if (locale === "sr") return sr_delete_account_confirm_warning(inputs)
	if (locale === "uk") return uk_delete_account_confirm_warning(inputs)
	if (locale === "ka") return ka_delete_account_confirm_warning(inputs)
	if (locale === "hi") return hi_delete_account_confirm_warning(inputs)
	if (locale === "th") return th_delete_account_confirm_warning(inputs)
	if (locale === "ko") return ko_delete_account_confirm_warning(inputs)
	if (locale === "zh") return zh_delete_account_confirm_warning(inputs)
	if (locale === "zh-tw") return zh_tw_delete_account_confirm_warning(inputs)
	if (locale === "ja") return ja_delete_account_confirm_warning(inputs)
	return en_delete_account_confirm_warning(inputs)
});